import React from "react";
import { Helmet } from "react-helmet-async";
const SEO = ({
  title,
  description,
  keywords,
  canonical,
  image,
  type,
  helpSections,
}) => {
  // Generate FAQ structured data
  // Generate FAQ structured data safely
  const faqItems =
    helpSections?.flatMap((section) =>
      section.items.map((item) => ({
        "@type": "Question",
        name: item.title,
        acceptedAnswer: {
          "@type": "Answer",
          text: item.description,
        },
      })),
    ) || [];

  return (
    <Helmet>
      {/* Basic SEO */}
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <link rel="canonical" href={canonical} />

      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonical} />
      <meta property="og:image" content="/favicon.svg" />
      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta property="twitter:image" content="/favicon.svg" />

      {/* Structured Data: Website / Breadcrumb / FAQ */}
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "WebSite",
          url: canonical,
          name: title,
          description: description,
          publisher: {
            "@type": "Organization",
            name: "xPage Inc.",
            logo: {
              "@type": "ImageObject",
              url: "/images/logo.png",
            },
          },
          breadcrumb: {
            "@type": "BreadcrumbList",
            itemListElement: [
              {
                "@type": "ListItem",
                position: 1,
                name: "Home",
                item: "https://help-center.preprod-myxpage.shop/",
              },
              {
                "@type": "ListItem",
                position: 2,
                name: "Help Center",
                item: canonical,
              },
            ],
          },
          mainEntity: faqItems,
        })}
      </script>
    </Helmet>
  );
};

export default SEO;
